import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { POPUP_MINIMIZED_WIDTH_SIZE } from '@app/main/main-content/floating-popup-manager/configs/floating-popup.config';
import { FloatingPopupLineChartWrapperComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-line-chart-wrapper/floating-popup-line-chart-wrapper.component';
import { ElementWidthClassDirective } from '@app/shared/directives/element-width-class-directive';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FpLoggerNoiseSpectrumStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum/fp-logger-noise-spectrum.store';
import { FpLoggerNoiseSpectrumChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum-chart.service';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';

@Component({
  selector: 'gc-fp-logger-noise-spectrum-minimized',
  standalone: true,
  imports: [ElementWidthClassDirective, FloatingPopupLineChartWrapperComponent, FloatingPopupBaseErrorMessageComponent],
  templateUrl: './fp-logger-noise-spectrum-minimized.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-full',
  },
})
export class FpLoggerNoiseSpectrumMinimizedComponent {
  public readonly currentTabStore = inject(FpLoggerNoiseSpectrumStore);
  protected readonly chartService = inject(FpLoggerNoiseSpectrumChartService);

  public popup = input<IFloatingPopupInstance>();

  public readonly POPUP_MINIMIZED_WIDTH_SIZE = POPUP_MINIMIZED_WIDTH_SIZE;

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  private readonly data = toSignal(this.currentTabStore.data$, {
    initialValue: null,
  });

  public error = toSignal(this.currentTabStore.error$, {
    initialValue: null,
  });

  public isChartDataExist = computed(() => !!this.data()?.length);

  public readonly loggerDeployment = computed(() => this.popupMainData()?.deployment);

  public combinedChartData = computed(() => {
    const data = this.data() || [];
    const chartData = this.chartService.getMinimizedDataForChart(data);
    const chartOptions = this.chartService.generateMinimizedOptions(data);
    return { chartData, chartOptions };
  });
}
